import {
  ACTION_SWITCH_SITE_STATUS__REQUEST,
  ACTION_SWITCH_SITE_STATUS__SUCCESS,
  ACTION_SWITCH_SITE_STATUS__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_SWITCH_SITE_STATUS__REQUEST:
    case ACTION_SWITCH_SITE_STATUS__SUCCESS:
      return null;

    case ACTION_SWITCH_SITE_STATUS__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
